import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "./api";

const BrandingContext = createContext(null);

export function useBranding() {
  return useContext(BrandingContext);
}

export function BrandingProvider({ children }) {
  const { hospCode } = useParams();
  const [hospital, setHospital] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hospCode) return;
    setLoading(true);
    api
      .getHospital(hospCode)
      .then((h) => {
        setHospital(h);
        document.documentElement.style.setProperty("--brand-primary", h.primary_color);
        document.documentElement.style.setProperty("--brand-secondary", h.secondary_color);
        setError(null);
      })
      .catch((e) => {
        setError(e?.response?.status === 404 ? "not_found" : "error");
      })
      .finally(() => setLoading(false));
    return () => {
      // reset on unmount
      document.documentElement.style.removeProperty("--brand-primary");
      document.documentElement.style.removeProperty("--brand-secondary");
    };
  }, [hospCode]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading hospital…</div>
      </div>
    );
  }

  if (error === "not_found") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-3 p-6 text-center">
        <div className="text-2xl font-semibold text-slate-900">Hospital not found</div>
        <div className="text-slate-500 max-w-md">
          The hospital code <span className="font-mono text-slate-700">"{hospCode}"</span> isn't registered.
          Check the URL or ask the Super-Admin to onboard your hospital.
        </div>
        <a href="/super-admin" className="mt-2 text-sm underline text-slate-700" data-testid="link-super-admin">
          Go to Super-Admin
        </a>
      </div>
    );
  }

  return (
    <BrandingContext.Provider value={{ hospital, hospCode }}>
      {children}
    </BrandingContext.Provider>
  );
}
